import { Component, Input, HostBinding, Output, EventEmitter } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import * as _ from 'lodash';
import { IAttributeModel } from 'src/app/interfaces/attribute-model.interface';

import ICalibrationSetAttribute = ZoneIQCalibration.ICalibrationSetAttribute;

@Component({
    standalone: false,
    selector: 'calibration-set-link-attribute',
    templateUrl: './calibration-set-link-attribute.component.html',
    styleUrls: ['./calibration-set-link-attribute.component.scss'],

})
export class CalibrationSetLinksComponent {

    constructor(private readonly dialog: MatDialog) { }

    @HostBinding('class')
    readonly hostClass = 'links';

    @Input()
    link?: IAttributeModel;

    @Input()
    index?: number;

    @Output()
    delete = new EventEmitter<number>();

    ngOnInit() {
    }

    isLinkValueValid() {
        return this.link.isValid;
    }

    isLinkValueChanged() {
        return this.link.IsChanged;
    }

    openLink() {
        window.open(this.link.AttributeValue, '_blank');
    }

    editLink() {
        this.link.IsEditableMode = true;
    }

    deleteLink() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '30%';
        dialogConfig.data = {
            title: 'Warning',
            topContent: `Are you sure to delete link?`
        };

        const publishDialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        publishDialogRef.afterClosed()
            .subscribe((needToDelete) => {
                if (!needToDelete) {
                    return;
                }
                this.delete.emit(this.index);
            });
    }

    cancelEditMode() {
        this.link.IsEditableMode = false;
        this.link.revertChanges();
    }

    updateLink() {
        this.link.IsEditableMode = false;
        (this.link as ICalibrationSetAttribute).Description = ((this.link as ICalibrationSetAttribute).Description || '').trim();
    }
}
